import { Outlet } from 'react-router-dom';
import Sidebar from '../Sidebar';
import './index.scss';

const Layout = () => {
    return (
        <div className="App">
            <Sidebar />
            <div className="page">
                <span className="tags top-tags">
                    <span className="top-tags-html">
                        <b>class</b> MySelf <b>&#123;</b>
                    </span>
                    <br />
                    <b>function</b> main ( ) <b>&#123;</b>
                </span>
                <Outlet />
                <span className="tags bottom-tags">
                    <b>&#125;</b> ;
                    <br />
                    <span className="bottom-tags-html">
                        <b>&#125;</b> ;
                    </span>
                </span>
            </div>
        </div>
    );
}

export default Layout;